export const channelsOverviewExtended = {
  cards: [
    {
      id: 'teams',
      name: 'Microsoft Teams',
      enabled: true,
      welcomeFlow: 'Adaptive card welcome + quick actions for booking and MOM.',
      lastTemplateUpdate: new Date(Date.now() - 86400000 * 2).toISOString(),
      messagesThisMonth: 1840,
      editPath: 'channels/teams',
    },
    {
      id: 'whatsapp',
      name: 'WhatsApp',
      enabled: true,
      welcomeFlow: 'Quick replies and list menus for self-serve booking.',
      lastTemplateUpdate: new Date(Date.now() - 86400000).toISOString(),
      messagesThisMonth: 620,
      editPath: 'channels/whatsapp',
    },
    {
      id: 'web',
      name: 'Web Portal',
      enabled: false,
      comingSoon: true,
      welcomeFlow: 'Browser-based booking desk (coming soon).',
      lastTemplateUpdate: null,
      messagesThisMonth: 0,
      editPath: null,
    },
  ],
  charts: {
    messagesByChannel7d: [
      { day: 'Mon', teams: 120, whatsapp: 45 },
      { day: 'Tue', teams: 132, whatsapp: 52 },
      { day: 'Wed', teams: 118, whatsapp: 61 },
      { day: 'Thu', teams: 140, whatsapp: 48 },
      { day: 'Fri', teams: 155, whatsapp: 70 },
      { day: 'Sat', teams: 40, whatsapp: 22 },
      { day: 'Sun', teams: 35, whatsapp: 18 },
    ],
    completionRate7d: [
      { day: 'Mon', pct: 82 },
      { day: 'Tue', pct: 85 },
      { day: 'Wed', pct: 79 },
      { day: 'Thu', pct: 88 },
      { day: 'Fri', pct: 90 },
      { day: 'Sat', pct: 72 },
      { day: 'Sun', pct: 68 },
    ],
  },
};

export const channelOverview = {
  teamsInstalled: true,
  teamsActiveUsers7d: 128,
  whatsappActiveUsers7d: 64,
  emailFallbackEnabled: true,
};

export const teamsMenuConfig = {
  botName: 'MeetingHub AI Assistant',
  welcomeTitle: 'Welcome to MeetingHub',
  welcomeBody: 'Book meetings, check availability, or fetch your latest MOM.',
  buttons: [
    { id: 'b1', label: 'Book Meeting', actionRoute: 'book', payloadName: 'book_flow' },
    { id: 'b2', label: 'My Meetings', actionRoute: 'list', payloadName: 'my_meetings' },
    { id: 'b3', label: 'Check Availability', actionRoute: 'freebusy', payloadName: 'availability' },
    { id: 'b4', label: 'MOM', actionRoute: 'mom', payloadName: 'last_mom' },
  ],
  fallbackMessage: "I didn't understand that. Try **Book**, **My meetings**, or **Help**.",
  defaultLocale: 'en',
};

export const whatsappMenuConfig = {
  menuType: 'quick_reply',
  quickReplies: [
    { id: 'q1', label: 'Book', action: 'book_flow' },
    { id: 'q2', label: 'Meetings', action: 'my_meetings' },
    { id: 'q3', label: 'Help', action: 'help' },
  ],
  followUp: {
    book_flow: 'Book Meeting flow',
    my_meetings: 'Show My Meetings',
    help: 'Help message',
  },
  flows: [
    { id: 'wf-1', name: 'Book meeting', entryKeyword: 'book' },
    { id: 'wf-2', name: 'Cancel meeting', entryKeyword: 'cancel' },
  ],
  businessHoursOnly: false,
};
